module.exports = __webpack_public_path__ + "static/media/substrate.2ce17e14.svg";


//////////////////
// WEBPACK FOOTER
// ./src/icons/substrate.svg
// module id = 220
// module chunks = 0